import { TCurrentUser } from "@/data/api/kili/current-user/current-user.type";

export type TEnvFeatureFlagUserBypass = (currentUser: TCurrentUser) => boolean;

export const isOperator: TEnvFeatureFlagUserBypass = (currentUser) => {
  return currentUser.isOperator ?? false;
};
